import { Link } from "react-router-dom"
import CartUpdater from "../../../context/cartUpdater"
import { formatPurchaseDate } from "../../../util/purchaseDate"
import "./ProductCard2.css"

const currency = new Intl.NumberFormat("en-PH", {
  style: "currency",
  currency: "PHP",
})

/**
 * Product card. It fills the width its container gives it, so the same card works in the
 * product grid (2 across on phones, more on wider screens) and in the swipeable home rows.
 */
const ProductCard = ({ product, order }) => {
  if (!product?.product_id) return null

  const price = Number(product.price || 0)
  const moq = Number(product.min_qty || 0)
  const filled = order?.qty || 0
  const pct = moq ? Math.min(100, Math.round((filled / moq) * 100)) : 0

  return (
    <div className="ProductCard text-black">
      <Link to={`/products/${product.product_id}`} className="product-card-img" tabIndex={-1} aria-hidden="true">
        <img src={product.image} alt="" loading="lazy" />
      </Link>

      <div className="product-card-body">
        <Link to={`/products/${product.product_id}`} className="card-name">
          {product.name}
        </Link>

        <div className="card-price">
          {currency.format(price)}
          <span className="card-unit"> / case</span>
        </div>

        <div className="card-moq">
          {moq} cases <span className="text-secondary">(MOQ)</span>
        </div>

        <div
          className="progress product-card-progress"
          role="progressbar"
          aria-label="Group order progress"
          aria-valuenow={filled}
          aria-valuemin={0}
          aria-valuemax={moq}
        >
          <div className={`progress-bar ${pct >= 100 ? "bg-success" : "bg-info"}`} style={{ width: `${pct}%` }} />
        </div>
        <div className="card-meta">
          {filled} / {moq} cases
        </div>

        <div className="card-meta mb-2">Purchase date: {formatPurchaseDate(product.category)}</div>

        <CartUpdater
          item={{ product, qty: 1, image: product.image }}
          classes="product-card-button btn-outline-success w-100 mt-auto"
        />
      </div>
    </div>
  )
}

export default ProductCard
